import { ChatType, FeedRoom, Comment, Message, SavedMessageType, SavedMessage } from "../../models";
import { CommentState, FeedRoomState, MessageState, SavedMessageState } from "../../redux";

export const findChatByChatId = (results: FeedRoom[], chatId: string): [FeedRoom, number] => {
    let ind = -1;
    const chat = results.find((res, i) => {
        const { chatType, chat, docId } = res;
        const resultChatId = chatType === 'Discussions' ? docId: chat.chatUId
        chatId === resultChatId && (ind = i)
        return chatId === resultChatId
    })
    return [chat as FeedRoom, ind]
}
export const findChatStateByChatId = (results: FeedRoomState[], chatId: string): [FeedRoomState, number] => {
    let ind = -1;
    const chat = results.find((res, i) => {
        const { chatType, chat, docId } = res.item;
        const resultChatId = chatType === 'Discussions' ? docId: chat.chatUId
        chatId === resultChatId && (ind = i)
        return chatId === resultChatId
    })
    return [chat as FeedRoomState, ind]
}
export const isDiscussions = (chatType: ChatType) => chatType === 'Discussions'

export const isExistComment = (id: string, comments: CommentState[], tempId?: string) => {
    const ind1 = !!tempId ? comments.findIndex((comment)=> tempId === comment.item.commentId) : -1
    const ind = comments.findIndex((comment)=> id === comment.item.commentId);
    return ind >= 0 || ind1 >= 0
}

export const withUpdateComment = (comments: CommentState[], comment: Comment, tempId?: string): CommentState[] => {
    if(!!tempId) {
        const updated = comments.map(commentState => {
            if(commentState.item.tempId !== tempId) return commentState
            commentState.item.commentId = comment.commentId
            commentState.item.tempId = null
            commentState.item.dateTime = comment.dateTime
            return commentState
        })    
        return updated
    }
    const filtered = comments.filter(commentState => commentState.item.commentId !== comment.commentId)    
    return [...filtered, {item: comment, isDeleting: false}]
}

export const withUpdateMessage = (messages: MessageState[], message: Message): MessageState[] => {
    const filtered = messages.filter(messageState => messageState.item.id !== message.id)
    return [...filtered, {item: message, isDeleting: false}]
}
export const withUpdateSavedMessage = (messages: SavedMessageState[], message: SavedMessage): SavedMessageState[] => {
    const filtered = messages.filter(messageState => messageState.item.message?.id !== message.message?.id)
    return [...filtered, {item: message, isDeleting: false}]
}

export const isExistMessage = (id: number, messages: MessageState[]) => {
    const ind = messages.findIndex((message)=> id === message.item.id);
    return ind >= 0
}
export const isExistSavedMessage = (type: SavedMessageType, id: number | string, savedMessages: SavedMessageState[]) => {
    const ind = savedMessages.findIndex((message)=> type === 0 ? id === message.item.comment?.commentId : id === message.item.message?.id);
    return ind >= 0
}

export const withFilterMessagesById = (messages: MessageState[]): MessageState[] => {
    return messages.filter((message,index,array)=>array.findIndex(val=>(val.item.id === message.item.id))===index)
} 

export const withFilterSavedMessagesById = (messages: SavedMessageState[]): SavedMessageState[] => {
    const filteredComments = messages.filter((message,index,array)=>array.findIndex(val=>(val.item.comment?.commentId === message.item.comment?.commentId))===index)
    const filteredMessages = filteredComments.filter((message,index,array)=>array.findIndex(val=>(val.item.message?.id === message.item.message?.id))===index)
    return filteredMessages
} 